import { InputAdornment } from '@mui/material';
import { FieldValues } from 'react-hook-form';

import {
  FormAwareTypeaheadMultiSelectInput,
  FormAwareTypeaheadMultiSelectInputProps,
} from '@/components/form/formAwareInputs/FormAwareTypeaheadMultiSelectInput';
import { Users01Icon } from '@/components/icons/Users01Icon';

import { useTeamsTypeahead } from './hooks/useTeamsTypeahead';

export type TeamsTypeaheadProps<FormShape extends FieldValues> = Omit<
  FormAwareTypeaheadMultiSelectInputProps<FormShape>,
  'options' | 'inputValue' | 'onInputChange'
> & {
  disableSCIMManagedTeams?: boolean;
};

export function TeamsTypeahead<FormShape extends FieldValues>(
  props: TeamsTypeaheadProps<FormShape>
) {
  const { disableSCIMManagedTeams = true, ...inputProps } = props;
  const { typeaheadProps } = useTeamsTypeahead<FormShape>(
    inputProps.fieldName,
    disableSCIMManagedTeams
  );

  return (
    <FormAwareTypeaheadMultiSelectInput<FormShape>
      {...typeaheadProps} // supplied by useAsyncTypeaheadProps
      {...inputProps} // label, fieldName, disabled, etc.
      placeholder="Select team(s)"
      startAdornment={
        <InputAdornment position="start">
          <Users01Icon size={16} />
        </InputAdornment>
      }
    />
  );
}
